var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.54076 2.15882C5.23305 1.96101 4.84189 1.947 4.52081 2.12229C4.19974 2.29758 4 2.63419 4 3V21C4 21.3658 4.19974 21.7024 4.52081 21.8777C4.84189 22.053 5.23305 22.039 5.54076 21.8412L19.5408 12.8412C19.827 12.6572 20 12.3403 20 12C20 11.6597 19.827 11.3428 19.5408 11.1588L5.54076 2.15882Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.57910211ad74b9d730ec202a4634c257.svg";
export { ForwardRef as ReactComponent };